import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';

import { getQuickCreateUrl } from 'chairisher/context/auth';

const FOLLOW_ICON_SELECTOR = '.js-follow-icon';

/**
 * A view which encapsulates logic around following a business
 *
 * @param {Object} settings The object containing the settings for the follow view
 * @param {Array.<number>} settings.followedBusinessIds
 */
class BusinessFollowView {
    constructor(settings = {}) {
        this.followedBusinessIds = settings.followedBusinessIds ?? [];
        this.initializeFollowIcons();
    }

    /**
     * CSS classes which can be applied to the follow icon.
     *
     * @enum {string}
     */
    static IconClass = {
        FOLLOWED: 'cicon-heart-fill',
        NOT_FOLLOWED: 'cicon-heart-stroke',
    };

    /**
     * Bind actions for this view.
     */
    bind() {
        const businessIdToXHRMap = {};

        $('.js-business-follow').on('click', (e) => {
            e.preventDefault();

            const $initiator = $(e.currentTarget);
            const businessId = $initiator.closest('.js-business').data('business-id');

            if (businessIdToXHRMap[businessId]) {
                return; // A request is already in flight.
            }

            $initiator.addClass('disabled');
            const isDeleteRequest = this.followedBusinessIds.includes(businessId);

            businessIdToXHRMap[businessId] = $.ajax({
                authUrl: getQuickCreateUrl('designer-follow'),
                method: isDeleteRequest ? 'delete' : 'post',
                url: $initiator.attr('href') || $initiator.data('url'),
            })
                .done((data) => {
                    if (isDeleteRequest) {
                        const index = this.followedBusinessIds.indexOf(businessId);
                        this.followedBusinessIds.splice(index, 1);
                    } else {
                        this.followedBusinessIds.push(businessId);
                    }

                    AlerterView.success(data.messages[0].message);

                    this.toggleFollowIcon($initiator, !isDeleteRequest);
                })
                .always(() => {
                    $initiator.removeClass('disabled');
                    delete businessIdToXHRMap[businessId]; // Mark request as finished
                });
        });
    }

    /**
     * Set the initial UI state for follow icons based on the list of followed businesses.
     */
    initializeFollowIcons() {
        const $businesses = $('.js-business');
        $.each($businesses, (i) => {
            const $business = $businesses.eq(i);
            const businessId = $business.data('business-id');
            if (this.followedBusinessIds.includes(businessId)) {
                this.toggleFollowIcon($business, true);
            }
        });
    }

    /**
     * Toggle a follow icon to indicate that a business is or is not followed.
     *
     * @param {jQuery} $el Element containing the icon.
     * @param {boolean} isFavorite Whether the business should be marked as followed.
     */
    toggleFollowIcon($el, isFavorite) {
        $el.find(FOLLOW_ICON_SELECTOR)
            .toggleClass(BusinessFollowView.IconClass.FOLLOWED, isFavorite)
            .toggleClass(BusinessFollowView.IconClass.NOT_FOLLOWED, !isFavorite);
    }
}

export default BusinessFollowView;
